<template>
  <div>
    <el-form :disabled="readonly" class="section" style="flex-direction: row;">
      <el-checkbox v-model="form.booking" no="booking">{{
        $t('SeaExport.Booking')
      }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val => {(form.customsBroker = val ? form.customsBroker : 0);form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.signMBL"
        no="signMBL"
        style="margin-left: -20px;"
        @change="pm.isMBLChange()"
      >MB/L
      </el-checkbox>
      <el-checkbox
        v-model="form.signHBL"
        no="signHBL"
        style="margin-left: -20px;"
        :disabled="form.mblOnly"
        @change="pm.isHBLChange()"
      >HB/L
      </el-checkbox>
      <el-checkbox v-model="form.virtualHBL" no="virtualHBL" style="margin-left: -20px;">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px;">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.hds" no="hds" style="margin-left: -20px;">HDS</el-checkbox>
      <el-checkbox v-model="form.comercialInspectation" no="comercialInspectation" style="margin-left: -20px;">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="form.heating" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="form.itmService" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <tab-buyer-console-fcl-booking-master-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.viewable" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input
          :value="form.jobNo"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerId.viewable" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageB"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <img
              :class="form.customerId&&readonly?'':'not-click'"
              :src="sopPic"
              width="18"
              height="28"
              class="sop-img"
              style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
              @click="pm.sopChangeCustomerIdHandler()"
            >
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageB"
            :content="warningImageBTip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-sales-company-select
            no="customerId"
            class="shipper-selector"
            popper-class="shipper-selector-popper"
            :method-params="{customer:true,companyLob:'seaExport',active:true}"
            :check-credit="true"
            :default-value="form.customerId||''"
            :disabled="readonly || !elementDict.customerId.writable || !customerEnabled"
            :job="form"
            style="flex: 1;"
            :latest-used-data-key="elementDict.customerId.userCustomContent && elementDict.customerId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-customerId' : ''"
            @parentCallBack="p=>{customerIdChange2ContractHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customerProperty.viewable" slot="customerProperty">
        <line-label slot="label" :class="elementDict.customerProperty.isRequire ? 'blue' : ''" :label="elementDict.customerProperty.label" />
        <el-tooltip :content="customerTip" placement="bottom">
          <span
            v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            class="orange"
          >LV{{ customerLevel.level }}</span>
          <span
            v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            style="color:#D3A73B"
          >&nbsp;{{ customerLevel.customerName }}</span>
          <span
            v-show="contractStatusLabel"
            class="red"
          >&nbsp;({{ contractStatusLabel }})</span>
          <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
          <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
            <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
          </span>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.viewable" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <div style="display: flex">
          <el-select
            v-model="form.customerContact"
            :disabled="readonly || !elementDict.customerContact.writable"
            no="customerContact"
            filterable
            :allow-create="true"
          >
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.contactPerson"
              :value="item.contactPerson"
            />
          </el-select>&nbsp;
          <el-link
            v-show="!isShowContactPersonDetail"
            no="customerContactLink"
            :class="form.customerContact?'':'not-click'"
            @click="showContactDialog"
          >{{ $t('SeaExport.Detail') }}
          </el-link>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.containerLoadType.viewable" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="form.containerLoadType"
          no="containerLoadType"
          :disabled="readonly || !elementDict.containerLoadType.writable || !containerLoadTypeEnabled"
          @change="val=>{pm.containerLoadTypeChange(val)}"
        >
          <el-option
            v-for="(item,index) in (containerLoadTypes)"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.viewable" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="cargoType"
          :select-type="selectTypeNames.basic_data_CargoType"
          :method-params="{ sea: true }"
          filterable
          :clearable="false"
          :default-value="form.cargoType"
          @parentCallBack="
            p => {
              form.cargoType = p.value;
              onCargoTypeChagne()
            }
          "
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesChannel.viewable" slot="salesChannel">
        <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
        <el-input
          :value="form.salesChannel"
          :disabled="true"
        />
      </el-form-item>
      <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
      <el-form-item v-if="elementDict.channelNo.viewable && showChannelNo" slot="channelNo">
        <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
        <el-input :value="form.channelNo" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.viewable" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex">
          <el-date-picker
            no="etd"
            class="departure-date-picker"
            :value="form.etd"
            :disabled="readonly || !elementDict.etd.writable || (form.lclMasterUuid?true:!etdEnabled) || !isJydEditJobFields"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1;margin-right: 5px"
            @input="etdChange"
            @change="onFieldChange('etd')"
          />&nbsp;
          <span>{{ form.sailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.viewable" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <el-date-picker
          v-model="form.eta"
          no="eta"
          :disabled="readonly || !elementDict.eta.writable || !lclslaveEnabled"
          style="width:100%"
          type="date"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.atd.viewable" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            :value="form.atd"
            no="atd"
            :disabled="readonly || !elementDict.atd.writable || !lclslaveEnabled"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="atdChange"
          />
          <span>{{ form.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.viewable" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.ata"
            no="ata"
            :disabled="readonly || !elementDict.ata.writable || !lclslaveEnabled"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="ataChange"
          />
          <span>{{ form.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.viewable" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker
          v-model="form.customsDate"
          no="customsDate"
          type="date"
          :disabled="readonly || !elementDict.customsDate.writable || !isJydUpdateCustomsDate"
          style="width:100%"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlace.viewable" slot="dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
        <el-input
          v-model="form.dispatchingPlace"
          :disabled="readonly || !elementDict.dispatchingPlace.writable"
          no="dispatchingPlace"
          @change="pm.cargoDocChangeHandler();pm.changeDispatchingPlace()"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.loadingPortCode.viewable" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <div style="display: flex; justify-content: space-between">
          <cargo-advance-select
            ref="loadingPortCode"
            no="loadingPortCode"
            :disabled="readonly || !elementDict.loadingPortCode.writable || !lclslaveEnabled"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.loadingPortCode"
            tag-name="englishName"
            style="flex:1"
            :latest-used-data-key="elementDict.loadingPortCode.userCustomContent && elementDict.loadingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-loadingPortCode' : ''"
            @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeLoadingPort();pm.setPlannerChange()}"
          />
          <template v-if="elementDict.transferPortCode.viewable">
            &nbsp;
            <el-checkbox v-model="form.transfering" :disabled="readonly || !elementDict.loadingPortCode.writable" no="transfering" style="padding-left:2px;">{{ fieldDict.transfering.label }}</el-checkbox>
          </template>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.transferPortCode.viewable && form.transfering" slot="transferPortCode">
        <line-label slot="label" :class="elementDict.transferPortCode.isRequire ? 'blue' : ''" :label="elementDict.transferPortCode.label" />
        <cargo-advance-select
          no="transferPortCode"
          :disabled="readonly || !elementDict.transferPortCode.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.transferPortCode"
          @parentCallBack="p=>{form.transferPortCode=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          no="dischargingPortCode"
          :disabled="readonly || !elementDict.dischargingPortCode.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode"
          :latest-used-data-key="elementDict.dischargingPortCode.userCustomContent && elementDict.dischargingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-dischargingPortCode' : ''"
          @parentCallBack="p=>{pm.dischargingPortCodeChange(p.value,form.carrierId);pm.cargoDocChangeHandler();pm.changeDischargingPort()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          no="destinationPortCode"
          class="port-of-delivery-selector"
          popper-class="port-of-delivery-selector-popper"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode"
          :disabled="readonly || !elementDict.destinationPortCode.writable"
          :latest-used-data-key="elementDict.destinationPortCode.userCustomContent && elementDict.destinationPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationPortCode' : ''"
          @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeDestinationPort()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselLine.viewable" slot="vesselLine">
        <line-label slot="label" :class="elementDict.vesselLine.isRequire ? 'blue' : ''" :label="elementDict.vesselLine.label" />
        <el-input
          :value="pm.vesselLine"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input
          v-model="form.destinationPlace"
          :disabled="readonly || !elementDict.destinationPlace.writable"
          no="destinationPlace"
          @change="pm.cargoDocChangeHandler();pm.changeDestinationPlace()"
        />
      </el-form-item>
      <!-- 船公司 -->
      <el-form-item v-if="elementDict.carrierId.viewable" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-company-select
          no="carrierId"
          :disabled="readonly || !elementDict.carrierId.writable || !carrierIdEnabled"
          :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
          :default-value="form.carrierId||''"
          :latest-used-data-key="elementDict.carrierId.userCustomContent && elementDict.carrierId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-carrierId' : ''"
          @change="p=>{form.carrierId=p.value;pm.carrierChangeHandler(form.dischargingPortCode, p.value)}"
          @blur="pm.carrierFocusOutEventHandler()"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.viewable && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          v-if="!bookingAgentDataProviderChange"
          no="bookingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          filterable
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
          :default-value="form.bookingAgent||''"
          :latest-used-data-key="elementDict.bookingAgent.userCustomContent && elementDict.bookingAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-bookingAgent' : ''"
          @parentCallBack="p=>{pm.bookingAgentChangeHandler(p)}"
        />
        <cargo-advance-select
          v-if="bookingAgentDataProviderChange"
          no="bookingAgent"
          :cache="false"
          :select-type="selectTypeNames.basic_data_Company"
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :default-value="form.bookingAgent||''"
          :static-options="pm.bookingAgentArray"
          @parentCallBack="p=>{form.bookingAgent = p.value;pm.bookingAgentChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierAgentId.viewable" slot="carrierAgentId">
        <line-label slot="label" :class="elementDict.carrierAgentId.isRequire ? 'blue' : ''" :label="elementDict.carrierAgentId.label" />
        <cargo-company-select
          no="carrierAgentId"
          :disabled="readonly || !elementDict.carrierAgentId.writable || !lclslaveEnabled"
          :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
          :default-value="form.carrierAgentId||''"
          @change="p=>{form.carrierAgentId=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.viewable" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <el-select
          v-model="form.cargoSource"
          no="cargoSource"
          :disabled="readonly || !elementDict.cargoSource.writable || !cargoSourceEnabled"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
          @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
        >
          <el-option
            v-for="(item,index) in CARGO_SOURCES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-show="elementDict.customJobType.viewable" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :static-options="customJobTypeList"
          :default-value="form.customJobType"
          :method-params="{type:form.lob}"
          :disabled="readonly || !elementDict.customJobType.writable"
          :tag-name="isZh?'name':'englishName'"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.viewable" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageC"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <img
              :class="form.destinationAgent&&readonly?'':'not-click'"
              :src="sopPic"
              width="18"
              height="28"
              class="sop-img"
              style="padding: 5px 0;cursor: pointer"
              @click="pm.sopChangeHandler()"
            >
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageC"
            :content="warningImageCTip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-advance-select
            no="destinationAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :disabled="readonly || !elementDict.destinationAgent.writable || !lclslaveEnabled"
            :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
            :default-value="form.destinationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :latest-used-data-key="elementDict.destinationAgent.userCustomContent && elementDict.destinationAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationAgent' : ''"
            @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
          <cargo-advance-select
            v-if="overseaAgentDataProviderChange"
            no="destinationAgent2"
            :select-type="selectTypeNames.basic_data_Company"
            :cache="false"
            :disabled="readonly || !elementDict.destinationAgent.writable || !lclslaveEnabled"
            :default-value="form.destinationAgent||''"
            filterable
            :check-credit="true"
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :static-options="pm.destinationAgentArray"
            :latest-used-data-key="elementDict.destinationAgent.userCustomContent && elementDict.destinationAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationAgent' : ''"
            @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.viewable && form.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageA"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <div>
              <img
                :class="form.designationAgent&&readonly?'':'not-click'"
                :src="sopPic"
                width="18"
                height="28"
                class="sop-img"
                style="padding: 5px 0;cursor: pointer"
                @click="pm.sopChangeBookingAgentHandler()"
              >
            </div>
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageA"
            :content="warningImageATip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-advance-select
            no="designationAgent"
            class="designation-agent-selector"
            popper-class="designation-agent-selector-popper"
            :select-type="selectTypeNames.basic_data_Company"
            :disabled="readonly || !elementDict.designationAgent.writable || !designationAgentEnabled"
            :method-params="{designationAgent:true,active:true}"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
          <cargo-advance-select
            v-if="overseaAgentDataProviderChange"
            no="designationAgent2"
            :select-type="selectTypeNames.basic_data_Company"
            :cache="false"
            :disabled="readonly || !elementDict.designationAgent.writable || !designationAgentEnabled"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :static-options="pm.designationAgentArray"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.localService.viewable" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="form.warehousing"
          :disabled="readonly || !elementDict.localService.writable"
          no="warehousing"
          @change="pm.loadingTermChange('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.landTransportation"
          :disabled="readonly || !elementDict.localService.writable"
          no="landTransportation"
          @change="pm.loadingTermChange('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.selfDeliver"
          :disabled="readonly || !elementDict.localService.writable"
          no="selfDeliver"
        >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
        </el-checkbox>
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseNo.viewable" slot="warehouseNo">
        <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
        <el-input
          v-model="form.warehouseNo"
          no="warehouseNo"
          style="margin-bottom: 10px;"
          :disabled="readonly || !elementDict.warehouseNo.writable || !pm.warehouseNoeditable"
        />
        <el-button
          :disabled="readonly || !elementDict.warehouseNo.writable || !(isEdit && isHbl)"
          no="warehouseNoBtn"
          type="primary"
          style="padding-left:13px;padding-right:13px;"
          @click="pm.clickWarehouseNoHandler()"
        >{{ $t('SeaExport.ObtainTheWarehouseNo') }}
        </el-button>
        <!--此功能屏蔽-->
        <!--<cargo-button-container :disabled="form.jobState!==0" @click="pm.autoAllocateExternalHandler()">
                  <el-button
                    type="primary"
                    style="padding-left:13px;padding-right:13px;"
                  >{{ $t('SeaExport.AutoDistribution') }}</el-button>
                </cargo-button-container>-->
      </el-form-item>
      <el-form-item v-if="elementDict.masterBusinessNo.viewable" slot="masterBusinessNo">
        <line-label slot="label" :class="elementDict.masterBusinessNo.isRequire ? 'blue' : ''" :label="elementDict.masterBusinessNo.label" />
        <el-input
          :disabled="true"
          :value="form.lclMaster?form.lclMaster.jobNo:''"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.customerRefNo.viewable"
        id="customerRefNo"
        slot="customerRefNo"
      >
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <el-tooltip
          :disabled="!customerRefNoTip"
          :content="customerRefNoTip"
          placement="right-end"
        >
          <el-input
            v-model="form.customerRefNo"
            :disabled="readonly || !elementDict.customerRefNo.writable"
            no="customerRefNo"
            :class="customerRefNoTip?'red':''"
            @blur="pm.customerRefNoFocusOutHandler()"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.viewable" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input
          v-if="!openProjectConfig"
          v-model="form.poNo"
          :disabled="readonly || !elementDict.poNo.writable"
          no="poNo"
        />
        <cargo-project-select
          v-if="openProjectConfig"
          no="poNo"
          :default-value="form.poNo"
          :disabled="readonly || !elementDict.poNo.writable"
          @change="p=>{form.poNo=p.value;form.projectName=p.projectName}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.viewable && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="form.projectName" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.projectBatch.viewable && openProjectConfig" slot="projectBatch">
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="form.projectBatch" :disabled="readonly" no="projectBatch" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.viewable" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          no="customsBroker"
          :disabled="readonly || !elementDict.customsBroker.writable || !customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="form.customsBroker||''"
          :placeholder="!customsBrokerEnabled? $t('SeaExport.PleaseTickCustomsDeclarationOption'):$t('CargoMsg.Cargo_keyWordsTip')"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          @parentCallBack="p=>{form.customsBroker = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.viewable" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="readonly || !elementDict.customsDeclarationType.writable || !customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
          filterable
          :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{form.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.viewable" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          :select-type="selectTypeNames.basic_data_TradeTerm"
          filterable
          :default-value="form.tradeTerm"
          :disabled="readonly || !elementDict.tradeTerm.writable"
          @parentCallBack="p=>{form.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.haulageCompany.viewable" slot="haulageCompany">
        <line-label slot="label" :class="elementDict.haulageCompany.isRequire ? 'blue' : ''" :label="elementDict.haulageCompany.label" />
        <cargo-company-select
          no="carryingCmp"
          :disabled="readonly || !elementDict.haulageCompany.writable || !form.landTransportation"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.carryingCmp||''"
          :placeholder="!form.landTransportation?$t('SeaExport.PleaseTickDoorLoadingDeliveryOption'):$t('CargoMsg.Cargo_keyWordsTip')"
          @change="p=>{pm.carryingCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseCmp.viewable" slot="warehouseCmp">
        <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
        <cargo-company-select
          no="warehouseCmp"
          :disabled="readonly || !elementDict.warehouseCmp.writable || !warehouseEabled"
          :method-params="{warehouse:true,active:true}"
          :default-value="form.warehouseCmp||''"
          :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.viewable" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTerm"
          :disabled="readonly || !elementDict.freightTerm.writable"
          @parentCallBack="p=>{form.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTermHBL.viewable && !form.mblOnly" slot="freightTermHBL">
        <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
        <cargo-advance-select
          no="freightTermHBL"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTermHBL"
          :disabled="readonly || !elementDict.freightTermHBL.writable"
          @parentCallBack="p=>{form.freightTermHBL=p.value;pm.freightTermHBLChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-advance-select
          no="paymentTermMBL"
          :disabled="readonly || !elementDict.paymentTermMBL.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="form.paymentTermMBL"
          @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfMblPayment.viewable" slot="placeOfMblPayment">
        <line-label slot="label" :class="elementDict.placeOfMblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfMblPayment.label" />
        <el-input
          v-show="!pm.isShowAcPaymentPlaceBL"
          v-model="mblDoc.paymentPlaceBL"
          no="paymentPlaceBL"
          :disabled="readonly || !elementDict.placeOfMblPayment.writable || !(isEdit && (form.paymentTermMBL==='3P' || form.paymentTermMBL==='PP'))"
          @change="pm.fieldChangeHandler()"
        />
        <cargo-advance-select
          v-if="pm.isShowAcPaymentPlaceBL"
          no="paymentPlaceBL"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="mblDoc.paymentPlaceBL||''"
          :disabled="readonly || !elementDict.placeOfMblPayment.writable"
          @parentCallBack="p=>{mblDoc.paymentPlaceBL = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermHBL.viewable && !form.mblOnly" slot="paymentTermHBL">
        <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
        <cargo-advance-select
          no="paymentTermHBL"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="form.paymentTermHBL"
          :disabled="readonly || !elementDict.paymentTermHBL.writable"
          :allow-create="true"
          @parentCallBack="p=>{pm.paymentSelectHblChange(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfHblPayment.viewable && !form.mblOnly" slot="placeOfHblPayment">
        <line-label slot="label" :class="elementDict.placeOfHblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfHblPayment.label" />
        <el-input v-model="hdoc.paymentPlaceBL" :disabled="readonly || !elementDict.placeOfHblPayment.writable" no="paymentPlaceBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingTerm.viewable" slot="bookingTerm">
        <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
        <el-select
          v-model="form.bookingTerm"
          no="bookingTerm"
          :disabled="readonly || !elementDict.bookingTerm.writable || !pm.bookingTermEditable"
          :placeholder="!pm.bookingTermEditable ? '' : $t('SeaExport.PleaseSelect')"
          :clearable="false"
          size="mini"
          @change="pm.bookingTermChange()"
        >
          <el-option
            v-for="(item,index) in bookingTerms"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.viewable" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          filterable
          :clearable="false"
          :default-value="form.incoTerm"
          :disabled="readonly || !elementDict.incoTerm.writable"
          @parentCallBack="p=>{form.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.measurements.viewable" slot="measurements">
        <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
        <el-input
          v-model="form.measurements"
          :disabled="readonly || !elementDict.measurements.writable"
          no="measurements"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.CargoSize'),form.measurements,val=>{form.measurements=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salePriceRemarks.viewable" slot="salePriceRemarks">
        <line-label slot="label" :class="elementDict.salePriceRemarks.isRequire ? 'blue' : ''" :label="elementDict.salePriceRemarks.label" />
        <el-input v-model="form.salePriceRemarks" :disabled="readonly || !elementDict.salePriceRemarks.writable" no="salePriceRemarks" />
      </el-form-item>
      <div v-if="elementDict.businessTags.viewable" slot="businessTags">
        <el-checkbox
          v-model="form.mblOnly"
          :disabled="readonly || !elementDict.businessTags.writable"
          no="mblOnly"
          style="margin: 0"
          @change="pm.isMblOnlyChange()"
        >{{ $t('SeaExport.DirectBusiness') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.transfering"
          no="transfering"
          :disabled="readonly || !elementDict.businessTags.writable || !lclslaveEnabled"
          style="margin: 0"
        >{{ $t('SeaExport.Transport') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.batch"
          no="batch"
          :disabled="readonly || !elementDict.businessTags.writable || !lclslaveEnabled"
          style="margin: 0"
        >{{ $t('SeaExport.InBatches') }}
        </el-checkbox>
        <el-checkbox v-model="form.salePrice" :disabled="readonly || !elementDict.businessTags.writable" no="salePrice">{{ $t('SeaExport.SpecialPrice') }}</el-checkbox>
      </div>
      <!-- 隐藏免柜租期 免堆天数 关区申请 代码撤回-->
      <el-form-item v-if="elementDict.freeDemurrage.viewable" slot="freeDemurrage">
        <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
        <el-input v-model="form.freeDemurrage" :disabled="readonly || !elementDict.freeDemurrage.writable" no="freeDemurrage" />
      </el-form-item>
      <el-form-item v-if="elementDict.freeDetention.viewable" slot="freeDetention">
        <line-label slot="label" :class="elementDict.freeDetention.isRequire ? 'blue' : ''" :label="elementDict.freeDetention.label" />
        <el-input v-model="form.freeDetention" :disabled="readonly || !elementDict.freeDetention.writable" no="freeDetention" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsAreaApplication.viewable" slot="customsAreaApplication">
        <line-label slot="label" :class="elementDict.customsAreaApplication.isRequire ? 'blue' : ''" :label="elementDict.customsAreaApplication.label" />
        <el-input v-model="form.customsAreaApplication" :disabled="readonly || !elementDict.customsAreaApplication.writable" no="customsAreaApplication" />
      </el-form-item>
      <booking-sea-eq-data-grid
        v-show="elementDict.seaEq.viewable"
        slot="seaEq"
        ref="bookingSeaEqDataGrid"
        no="bookingSeaEqDataGrid"
        :value="seaEqList"
        :container-load-type="form.containerLoadType"
        :is-edit="isEdit && elementDict.seaEq.writable"
        :job="form"
      />
      <el-form-item v-show="elementDict.quantityConsignActual.viewable" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.quantityContract"
            no="quantityContract"
            :precision="0"
            :min="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || !isJydEditJobFields"
            @change="pm.jobContractQwcChange(1)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="quantityActual"
            v-model="form.quantityActual"
            no="quantityActual"
            :precision="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || pm.billChargeFlag || !isJydEditJobFields"
            :min="0"
            @change="
              SEUtils.changeQWCRule(null, () => {
                form.quantityContract = form.quantityActual
              })
              pm.changeSynBillOfLadingQWC()
              pm.txtPackingChangeHandler()
              pm.refContainerUsageQwc(2)
            "
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.weightConsignActual.viewable" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.weightContract"
            no="weightContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.weightConsignActual.writable || !isJydEditJobFields"
            @change="pm.jobContractQwcChange(2)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="weightActual"
            v-model="form.weightActual"
            no="weightActual"
            :precision="3"
            :disabled="readonly || !elementDict.weightConsignActual.writable || pm.billChargeFlag || !isJydEditJobFields"
            :min="0"
            @change="
              SEUtils.changeQWCRule(null, () => {
                form.weightContract = form.weightActual
              })
              pm.calculateChargeWeight()
              pm.refContainerUsageQwc(2)
            "
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.cubageConsignActual.viewable" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.cubageContract"
            no="cubageContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !isJydEditJobFields"
            @change="pm.jobContractQwcChange(3)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="cubageActual"
            v-model="form.cubageActual"
            no="cubageActual"
            :precision="3"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !cubageActualEnabled || !isJydEditJobFields"
            :min="0"
            @change="
              SEUtils.changeQWCRule(null, () => {
                form.cubageContract = form.cubageActual
                form.chargeWeight = form.cubageActual
              })
              pm.calculateChargeWeight()
              pm.refContainerUsageQwc(2, false)
            "
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.packing.viewable" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :default-value="form.packing"
          :disabled="readonly || !elementDict.packing.writable"
          @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="form.insideQuantity"
          :disabled="readonly || !elementDict.insideQuantity.writable"
          no="insideQuantity"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="insidePacking"
          :default-value="form.insidePacking"
          :disabled="readonly || !elementDict.insidePacking.writable"
          @change="p=>{form.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.viewable" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex">
          <el-input-number
            :value="form.chargeWeight || undefined"
            no="chargeWeight"
            :precision="3"
            :controls="false"
            style="flex:1"
            :disabled="readonly || !elementDict.chargeWeight.writable || !chargeWeightEnabled"
            :min="0"
            @input="
              val => {
                form.chargeWeight = val
              }
            "
            @change="pm.changeSynBillOfLadingQWC()"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
        <el-form-item v-show="isEdit && elementDict.cargoEnglishName.writable">
          <div slot="label">
            <el-button
              no="Copy2"
              type="primary"
              @click="transcribeDialog.visible=true"
            >{{ $t('SeaExport.Copy2') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <div style="position:relative">
            <cargo-textarea
              ref="cargoTextarea1"
              v-model="form.cargoEnglishName"
              no="cargoEnglishName"
              type="textarea"
              :rows="5"
              :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
              :auto-uppercase="isUppercaseByConfig"
              wrap-symbol="r"
              @change="onCargoEnglishNameChange"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,form.cargoEnglishName,val=>{form.cargoEnglishName = val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
            <char-count :value="form.cargoEnglishName" />
          </div>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.mark.viewable" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <div style="position:relative">
          <cargo-textarea
            ref="cargoTextarea2"
            v-model="form.mark"
            no="mark"
            type="textarea"
            :rows="5"
            wrap-symbol="r"
            :disabled="!isEdit || !elementDict.mark.writable"
            :auto-uppercase="isUppercaseByConfig"
            @change="onMarkChange"
            @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,form.mark,val=>{form.mark = val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
          />
          <char-count :value="form.mark" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
        <div slot="label">
          <line-label :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.hsCode.writable"
            no="HsCodeBtn"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),val=>{form.hsCode = p.code})"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <el-input
          v-model="form.hsCode"
          :disabled="readonly || !elementDict.hsCode.writable"
          no="hsCode"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.hsCode.label,form.hsCode,val=>{form.hsCode = val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.viewable" slot="cargoChineseName">
        <div slot="label">
          <line-label :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.cargoChineseName.writable"
            no="cargoChineseNameBtn"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>form.cargoChineseName=p.commodityName)"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <div style="position:relative">
          <cargo-textarea
            v-model="form.cargoChineseName"
            no="cargoChineseName"
            :disabled="!isEdit || !elementDict.cargoChineseName.writable"
            type="textarea"
            :rows="5"
            :auto-uppercase="false"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,form.cargoChineseName,val=>{form.cargoChineseName=val})"
          />
          <char-count :value="form.cargoChineseName" />
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoCode.viewable" slot="cargoCode">
        <el-form-item class="custom">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="cargoCode"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            :disabled="readonly || !elementDict.cargoCode.writable"
            filterable
            :clearable="true"
            :default-value="form.cargoCode"
            :allow-create="false"
            @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.cargoName"
            no="cargoName"
            :disabled="readonly || !elementDict.cargoCode.writable || !(isEdit && form.cargoCode)"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.salesCompany.viewable" slot="salesCompany">
        <line-label slot="label" :class="elementDict.salesCompany.isRequire ? 'blue' : ''" :label="elementDict.salesCompany.label" />
        <el-input
          :value="txtSalesOffice"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.sales.viewable" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <div style="display: flex;justify-content: space-between">
          <cargo-user-select
            ref="sales"
            no="sales"
            :disabled="readonly || !elementDict.sales.writable || !saleEnabled"
            :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
            :default-value="form.sales||''"
            :static-options="salesList"
            :placeholder="salesPrompt"
            :merge-load="true"
            style="flex: 1"
            @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
          />&nbsp;
          <el-checkbox
            v-model="form.provisioned"
            no="provisioned"
            style="margin-left: 5px"
            :disabled="true"
          >{{ fieldDict.provisioned.label }}
          </el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.viewable" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="form.cargoSalesId||''"
          :disabled="readonly || !elementDict.cargoSalesId.writable"
          :static-options="cargoSalesList"
          @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.viewable" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesDepartment"
          :disabled="readonly || !elementDict.salesDepartment.writable || !form.sales"
          :sales-id="Number(form.sales)"
          :office-id="form.salesOffice"
          :department-id="Number(form.salesDepartment)"
          @change="p=>{form.salesDepartment=p.value;pm.departmentChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.viewable" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-office-select
          no="opOffice"
          :disabled="readonly || !elementDict.opOffice.writable || (!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
          :is-regional-commission="isRegionalCommission"
          :office-id="Number(form.opOffice)"
          @change="p=>{form.opOffice=p.value;form.opDepartment=0;pm.opOfficeChangeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.viewable" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="opDepartment"
          :disabled="readonly || !elementDict.opDepartment.writable || pm.isWithinCloseAccountDate"
          :office-id="Number(form.opOffice)"
          :department-id="Number(form.opDepartment)"
          @change="p=>{form.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.op.viewable" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          ref="op"
          no="op"
          :disabled="readonly || !elementDict.op.writable || !opEabled"
          :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
          :default-value="form.op||''"
          :static-options="userPortRoleData.op"
          @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.viewable" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-office-select
          no="csrOffice"
          :disabled="true"
          :office-id="Number(form.csrOffice)"
          @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.viewable" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :office-id="Number(form.csrOffice)"
          :enables="true"
          :department-id="Number(form.csrDepartment)"
          :disabled="readonly || !elementDict.csrDepartment.writable"
          @change="p=>{form.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.csr.viewable" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          ref="csr"
          no="csr"
          :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
          :default-value="form.csr||''"
          :disabled="readonly || !elementDict.csr.writable"
          :merge-load="true"
          :static-options="userPortRoleData.csr"
          @change="p=>{pm.csrChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.viewable" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
          :default-value="form.siteOP||''"
          :disabled="readonly || !elementDict.siteOP.writable"
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.overseaOp.viewable" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          :default-value="form.overseaOp||''"
          :disabled="readonly || !elementDict.overseaOp.writable"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.viewable" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-office-select
          no="dcOffice"
          :disabled="true"
          :office-id="Number(form.dcOffice)"
          @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.viewable" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :office-id="Number(form.dcOffice)"
          :enables="true"
          :department-id="Number(form.dcDepartment)"
          :disabled="readonly || !elementDict.dcDepartment.writable"
          @change="p=>{form.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.dc.viewable" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          ref="dc"
          no="dc"
          :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          :disabled="readonly || !elementDict.dc.writable"
          :static-options="userPortRoleData.doc"
          @change="p=>{pm.dcChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.viewable" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(form.plannerOffice)"
          @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.viewable" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :office-id="Number(form.plannerOffice)"
          :enables="true"
          :department-id="Number(form.plannerDepartment)"
          :disabled="readonly || !elementDict.plannerDepartment.writable"
          @change="p=>{form.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.viewable" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :method-params="{officeId:form.opOffice,category:'role',shape:'seaLine'}"
          :default-value="form.planner||''"
          :disabled="readonly || !elementDict.planner.writable"
          :static-options="userPortRoleData.seaLine"
          @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <special-requests-grid
        v-show="elementDict.satisfiedRequests.viewable"
        slot="satisfiedRequests"
        ref="selectedSpecialRequest"
        v-model="form.satisfiedRequests"
        no="satisfiedRequests"
        :is-edit="isEdit && elementDict.satisfiedRequests.writable"
        :customer-id="Number(form.customerId)"
        :lob="form.lob"
        :job="form"
        style="margin-bottom: 5px"
      />
      <el-form-item v-if="elementDict.operationContent.viewable" slot="operationContent">
        <line-label slot="label" :class="elementDict.operationContent.isRequire ? 'blue' : ''" :label="elementDict.operationContent.label" />
        <el-tooltip
          :content="form.operationContent"
          placement="left"
        >
          <div
            slot="content"
            v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
          />
          <el-input
            no="operationContent"
            :value="form.operationContent"
            :disabled="readonly || !elementDict.operationContent.writable"
            :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
            type="textarea"
            :rows="4"
            @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit||lockJobByPrintHblZb"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.operationTips.viewable" slot="operationTips">
        <line-label slot="label" :class="elementDict.operationTips.isRequire ? 'blue' : ''" :label="elementDict.operationTips.label" />
        <el-input
          v-model="form.operationTips"
          :disabled="readonly || !elementDict.operationTips.writable"
          no="operationTips"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.operationTips.label,form.operationTips,val=>{form.operationTips=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.surchargeTerms.viewable" slot="surchargeTerms">
        <line-label slot="label" :class="elementDict.surchargeTerms.isRequire ? 'blue' : ''" :label="elementDict.surchargeTerms.label" />
        <el-input
          no="txtSurchargeTerms"
          :value="txtSurchargeTerms"
          :disabled="readonly || !elementDict.surchargeTerms.writable"
          :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
          type="textarea"
          :rows="4"
          @dblclick.native="selectSurchargeTermsDialog.rowData=form.surchargeTerms;selectSurchargeTermsDialog.visible=true"
        />
      </el-form-item>
      <!--港前商务负责人-->
      <el-form-item v-if="elementDict.prePortPlanner && elementDict.prePortPlanner.viewable" slot="prePortPlanner">
        <line-label slot="label" :class="elementDict.prePortPlanner.isRequire ? 'blue' : ''" :label="elementDict.prePortPlanner.label" />
        <cargo-user-select
          no="prePortPlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.prePortPlanner||''"
          placeholder=" "
          @change="p=>{pm.prePortPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--尾程商务负责人-->
      <el-form-item v-if="elementDict.lastMilePlanner && elementDict.lastMilePlanner.viewable" slot="lastMilePlanner">
        <line-label slot="label" :class="elementDict.lastMilePlanner.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlanner.label" />
        <cargo-user-select
          no="lastMilePlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.lastMilePlanner||''"
          placeholder=" "
          @change="p=>{pm.lastMilePlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--港前商务负责人部门-->
      <el-form-item v-if="elementDict.prePortPlannerDepartment && elementDict.prePortPlannerDepartment.visible" slot="prePortPlannerDepartment">
        <line-label slot="label" :class="elementDict.prePortPlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerDepartment.label" />
        <cargo-department-select
          no="prePortPlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.prePortPlannerOffice)"
          :enables="true"
          :department-id="Number(form.prePortPlannerDepartment)"
          @change="p=>{form.prePortPlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人部门-->
      <el-form-item v-if="elementDict.lastMilePlannerDepartment && elementDict.lastMilePlannerDepartment.visible" slot="lastMilePlannerDepartment">
        <line-label slot="label" :class="elementDict.lastMilePlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerDepartment.label" />
        <cargo-department-select
          no="lastMilePlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.lastMilePlannerOffice)"
          :enables="true"
          :department-id="Number(form.lastMilePlannerDepartment)"
          @change="p=>{form.lastMilePlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--港前商务负责人公司-->
      <el-form-item v-if="elementDict.prePortPlannerOffice && elementDict.prePortPlannerOffice.visible" slot="prePortPlannerOffice">
        <line-label slot="label" :class="elementDict.prePortPlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerOffice.label" />
        <cargo-advance-select
          no="prePortPlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.prePortPlannerOffice||''"
          @parentCallBack="p=>{form.prePortPlannerOffice=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人公司-->
      <el-form-item v-if="elementDict.lastMilePlannerOffice && elementDict.lastMilePlannerOffice.visible" slot="lastMilePlannerOffice">
        <line-label slot="label" :class="elementDict.lastMilePlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerOffice.label" />
        <cargo-advance-select
          no="lastMilePlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.lastMilePlannerOffice||''"
          @parentCallBack="p=>{form.lastMilePlannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtWhs.viewable" slot="txtWhs">
        <line-label slot="label" :class="elementDict.txtWhs.isRequire ? 'blue' : ''" :label="elementDict.txtWhs.label" />
        <el-input
          no="txtWhs"
          :disabled="true"
          type="textarea"
          :rows="4"
          :value="txtWhs"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          :disabled="readonly || !elementDict.remarks.writable"
          no="remarks"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,form.remarks,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.viewable" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="form.userDefinedField1"
          :disabled="readonly || !elementDict.userDefinedField1.writable"
          no="userDefinedField1"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,form.userDefinedField1,val=>{form.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.viewable" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="form.userDefinedField2"
          :disabled="readonly || !elementDict.userDefinedField2.writable"
          no="userDefinedField2"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,form.userDefinedField2,val=>{form.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.viewable" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="form.userDefinedField3"
          :disabled="readonly || !elementDict.userDefinedField3.writable"
          no="userDefinedField3"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,form.userDefinedField3,val=>{form.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.viewable" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="form.userDefinedField4"
          :disabled="readonly || !elementDict.userDefinedField4.writable"
          no="userDefinedField4"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,form.userDefinedField4,val=>{form.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.viewable" slot="exportControlledProduct">
        <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
        <el-select
          v-model="form.exportControlledProduct"
          no="exportControlledProduct"
          :disabled="readonly || !elementDict.exportControlledProduct.writable"
          :placeholder="''"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.viewable" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="form.taxNature"
          :disabled="readonly || !elementDict.taxNature.writable"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.viewable" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="form.rateType"
          :disabled="readonly || !elementDict.rateType.writable"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.loadingAgentId && elementDict.loadingAgentId.viewable" slot="loadingAgentId">
        <line-label slot="label" :class="elementDict.loadingAgentId.isRequire ? 'blue' : ''" :label="elementDict.loadingAgentId.label" />
        <cargo-company-select
          :method-params="{localAgent:true,active: true}"
          no="loadingAgentId"
          :disabled="readonly || !elementDict.loadingAgentId.writable"
          :default-value="form.loadingAgentId||''"
          :data-filter-function="JobUtils.loadingAgentIdFilter"
          :tag-name="isZh ? 'chineseName' : 'englishName'"
          @change="p=>{form.loadingAgentId = p.value}"
        />
      </el-form-item>
      <el-form
        v-show="elementDict.shipper.viewable"
        slot="shipper"
        :disabled="readonly || !elementDict.shipper.writable"
        label-width="63px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
            <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            :method-params="{ shipper: true, active: true }"
            no="shipperId"
            :default-value="form.shipperId || ''"
            style="display: inline-block;width:175px;margin-right: 5px"
            @change="
              data => {
                pm.shipperChange(data)
              }
            "
          />&nbsp;
          <el-button
            type="primary"
            no="billAddressDialogBtn"
            style="vertical-align: top"
            @click="billAddressDialog.visible = true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'shipperLine' + i"
            v-model="form['shipperLine' + i]"
            :no="'shipperLine' + i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="
              () =>
                wrapAddr(
                  form,
                  'shipperLine' + i,
                  i + 1 > 6 ? null : 'shipperLine' + (i + 1),
                  200
                )
            "
            @dblclick.native="
              showAdvanceTextDialog(
                $t('SeaExport.Shipper'),
                mergeShipperLine(),
                splitShipperLine,
                notUppercaseShipperConsigneNotify
              )
            "
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.viewable"
        slot="consignee"
        :disabled="readonly || !elementDict.consignee.writable"
        label-width="63px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
            <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            no="consigneeId"
            :method-params="{ consignee: true, active: true }"
            :default-value="form.consigneeId || ''"
            style="display: inline-block;width:175px;margin-right: 5px"
            @change="
              data => {
                pm.consigneeChange(data)
              }
            "
          />&nbsp;
          <el-button
            no="consigneeIdBtn"
            type="primary"
            style="vertical-align: top"
            @click="billAddressDialog.visible = true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'consigneeLine' + i"
            v-model="form['consigneeLine' + i]"
            :no="'consigneeLine' + i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="
              () =>
                wrapAddr(
                  form,
                  'consigneeLine' + i,
                  i + 1 > 6 ? null : 'consigneeLine' + (i + 1),
                  200
                )
            "
            @dblclick.native="
              showAdvanceTextDialog(
                $t('SeaExport.Consignee'),
                mergeConsigneeLine(),
                splitConsigneeLine,
                notUppercaseShipperConsigneNotify
              )
            "
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.viewable"
        slot="notify"
        :disabled="readonly || !elementDict.notify.writable"
        label-width="63px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
            <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            no="notifyId"
            :method-params="{ notify: true, active: true }"
            :default-value="form.notifyId || ''"
            style="display: inline-block;width:175px;margin-right: 5px"
            @change="
              data => {
                pm.notifyChange(data)
              }
            "
          />&nbsp;
          <el-button
            no="notifyIdBtn"
            type="primary"
            style="vertical-align: top"
            @click="billAddressDialog.visible = true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'notifyLine' + i"
            v-model="form['notifyLine' + i]"
            :no="'notifyLine' + i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="
              () =>
                wrapAddr(
                  form,
                  'notifyLine' + i,
                  i + 1 > 6 ? null : 'notifyLine' + (i + 1),
                  200
                )
            "
            @dblclick.native="
              showAdvanceTextDialog(
                $t('SeaExport.NotifyParty'),
                mergeNotifyLine(),
                splitNotifyLine,
                notUppercaseShipperConsigneNotify
              )
            "
          />
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="form.alsoNotify"
          no="alsoNotify"
          :disabled="readonly || !elementDict.alsoNotify.writable"
          type="textarea"
          wrap-symbol="r"
          class="also-notify"
          @dblclick.native="
            showAdvanceTextDialog(
              $t('SeaExport.SecondNotifyParty'),
              form.alsoNotify,
              val => {
                form.alsoNotify = val
              },
              notUppercaseShipperConsigneNotify,
              { warningCount: 45, maxChar: 0 }
            )
          "
        />
      </div>
      <div slot="ticketsInfo" class="section" style="width: 100%;">
        <div class="title">
          {{ $t('SeaExport.TicketsInfo') }}
          <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
            <div class="line" style="margin-top:2px" />
            <div class="line" />
          </div>
        </div>
        <div style="display:flex;flex-direction:column;margin-bottom: 5px;line-height: 28px;">
          <div style="padding:5px 0">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ form.lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" style="display: inline-flex;">
              <el-button
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="NewTickets"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="EditTickets"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="AddTickets"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="RemoveTickets"
                type="danger"
                @click="pm.btnRemoveBatchClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="DeleteTickets"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div ref="slaveDiv" style="display: flex;">
            <cargo-ag-grid
              config-module="130135"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </tab-buyer-console-fcl-booking-master-UICustom-layout>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-position="right" label-width="100px">
        <el-form-item :label="$t('SeaExport.ContactPerson') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="advanceTextDialogConfirm" type="primary" @click="finishAdvanceText">{{
          $t('common.btn.confirm')
        }}</el-button>
        <el-button no="advanceTextDialogClose" @click="advanceTextDialog.visible = false">{{
          $t('common.btn.close')
        }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="SE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="selectOperationReqDialog.value"
      @callback="val => (form.operationContent = val)"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" no="ticketDialogConfirm" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button type="primary" no="ticketDialogCancel" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBuyerConsoleFclBookingMasterUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBuyerConsoleFclBookingMasterUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBuyerConsoleFclBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBuyerConsoleFclBookingMaster'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'TabBuyerConsoleFclBookingMasterUICustom',
  components: { cargoTextarea, tabBuyerConsoleFclBookingMasterUICustomLayout },
  extends: tabBuyerConsoleFclBookingMaster,
  data() {
    return {
      TYPE_NAMES,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }
  },
  async created() {
    this.loadPageConfig()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_BASIC, this.elementDict, row, true)
        if (!row.uuid) {
          this.onFieldChange('etd')
        }
      }
    },
    loadPageConfig() {
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_BASIC, this.$store.getters.currentOfficeId, true)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
    },
    async validateForm() {
      const form = this.form
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (fieldName === 'agentRefNo') {
            continue
          }
          if (fieldName === 'projectName' || fieldName === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (fieldName === 'freightTermHBL' || fieldName === 'paymentTermHBL') {
            if (form.mblOnly) {
              continue
            }
          }
          if (['exChangeAgent', 'transportSource', 'statisticArea', 'placeOfDeliveryRegion', 'bookingDate', 'terminalCompany', 'userDefinedRoleId1', 'userDefinedRoleId2'].includes(fieldName)) {
            continue
          }
          if (fieldName === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
            continue
          }
          if (fieldName === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
            continue
          }
          if (fieldName === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
            continue
          }
          if (fieldName.startsWith('shipperLine') || fieldName.startsWith('consigneeLine') || fieldName.startsWith('notifyLine')) {
            continue
          }
          if (fieldName.startsWith('shipperCode') || fieldName.startsWith('consigneeCode') || fieldName.startsWith('notifyCode')) {
            continue
          }
          if (fieldName === 'transferPortCode') {
            if (form.transfering && StrUtils.isEmpty(form.transferPortCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
          } else if (fieldName === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBuyerConsoleFclBookingMaster')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.viewable && this.elementDict.seaEq.writable && this.elementDict.seaEq.isRequire) {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBuyerConsoleFclBookingMaster')
        }
        for (const seaEq of this.seaEqList) {
          if (!seaEq.eqQuantity) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBuyerConsoleFclBookingMaster')
          }
        }
      }
      if (this.elementDict.haulageCompany && this.elementDict.haulageCompany.viewable && this.elementDict.haulageCompany.writable && this.elementDict.haulageCompany.isRequire) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.haulageCompany.label]), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.viewable && this.elementDict.warehouseCmp.writable && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (this.elementDict.surchargeTerms && this.elementDict.surchargeTerms.viewable && this.elementDict.surchargeTerms.writable && this.elementDict.surchargeTerms.isRequire) {
        if (StrUtils.isEmpty(this.txtSurchargeTerms)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.surchargeTerms.label]), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (this.elementDict.satisfiedRequests && this.elementDict.satisfiedRequests.viewable && this.elementDict.satisfiedRequests.writable && this.elementDict.satisfiedRequests.isRequire) {
        if (StrUtils.isEmpty(this.form.satisfiedRequests)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.satisfiedRequests.label]), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    onFieldChange(fieldName) {
      UICustomUtil.handleFieldChange(UICustomConstants.SEA_BOOKING_MODULE, UICustomConstants.SEA_BOOKING_BASIC, this.form, fieldName, this.context.modifiedData)
    }
  }
}
</script>

<style scoped>
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
</style>
<style lang="scss" scoped>
.form-item-label {
  .el-form-item {
    /deep/.el-form-item__label {
      width: 105px !important;
    }
    /deep/.el-form-item__content {
      margin-left: 105px !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
/deep/ .also-notify {
  width: 310px;
  .el-textarea__inner {
    height: 230px;
  }
}
</style>
